"use client";
import { useRuntimeConfig } from "@lib/env";
import ButtonCustom from "../button-custom";

type Props = {
  title: string;
  variant?: "primary" | "secondary";
  platform?: "facebook" | "zalo";
};

function ContactButton({ title, variant = "primary", platform = "facebook" }: Props) {
  const { config, loading } = useRuntimeConfig();

  const handleClick = () => {
    if (loading) return;

    switch (platform) {
      case "zalo": {
        const zaloOAId = config.NEXT_PUBLIC_ZALO;
        if (!zaloOAId) {
          console.error("Zalo OA ID không được thiết lập!");
          return;
        }
        window.open(`https://zalo.me/${zaloOAId}`, "_blank");
        break;
      }
      case "facebook":
      default: {
        const fbMessenger = config.NEXT_PUBLIC_FACEBOOK_MESSENGER;
        if (!fbMessenger) {
          console.error("Facebook Messenger link không được thiết lập!");
          return;
        }
        window.open(fbMessenger, "_blank");
        break;
      }
    }
  };

  return (
    <ButtonCustom variant={variant} onClick={handleClick} disabled={loading}>
      {title}
    </ButtonCustom>
  );
}

export default ContactButton;
